import { isPresent, Nullish } from '../utils/typescript';
import i18n from '@/general/i18n';

export type CountryCode = string;

export interface CountryId {__countryId: number;}

export const KNOWN_COUNTRY_IDS = {
  DEFAULT: 1 as unknown as CountryId,
  BELGIUM: 1 as unknown as CountryId,
  THE_NETHERLANDS: 2 as unknown as CountryId,
  LUXEMBOURG: 3 as unknown as CountryId,
  GERMANY: 4 as unknown as CountryId,
  FRANCE: 5 as unknown as CountryId,
  UNITED_KINGDOM: 6 as unknown as CountryId,
  ROMANIA: 7 as unknown as CountryId,
};

export const KNOWN_COUNTRY_CODES = Object.values(KNOWN_COUNTRY_IDS).map(getCountryCode).filter(isPresent).filter((item, index, arr) => arr.indexOf(item) === index);

let DEFAULT_COUNTRY_ID = KNOWN_COUNTRY_IDS.BELGIUM;

/**
 * "Temporary" workaround to support cases where countryId is not provided by the backend
 * DO NOT USE if better data is available!
 */
export function getDefaultCountryId(): CountryId {
  return DEFAULT_COUNTRY_ID;
}

export function setDefaultCountryId(id: Nullish<CountryId>): void {
  DEFAULT_COUNTRY_ID = id ?? DEFAULT_COUNTRY_ID;
}

export function getCountryCode(id: Nullish<CountryId>): CountryCode | undefined {
  switch (id) {
    case KNOWN_COUNTRY_IDS.BELGIUM:
      return 'be';
    case KNOWN_COUNTRY_IDS.THE_NETHERLANDS:
      return 'nl';
    case KNOWN_COUNTRY_IDS.LUXEMBOURG:
      return 'lu';
    case KNOWN_COUNTRY_IDS.GERMANY:
      return 'de';
    case KNOWN_COUNTRY_IDS.FRANCE:
      return 'fr';
    case KNOWN_COUNTRY_IDS.UNITED_KINGDOM:
      return 'gb';
    case KNOWN_COUNTRY_IDS.ROMANIA:
      return 'ro';
  }
}

export function getCountryName(id: Nullish<CountryId>): CountryCode | undefined {
  switch (id) {
    case KNOWN_COUNTRY_IDS.BELGIUM:
      return i18n.global.t('country.belgium');
    case KNOWN_COUNTRY_IDS.THE_NETHERLANDS:
      return i18n.global.t('country.netherlands');
    case KNOWN_COUNTRY_IDS.LUXEMBOURG:
      return i18n.global.t('country.luxembourg');
    case KNOWN_COUNTRY_IDS.GERMANY:
      return i18n.global.t('country.germany');
    case KNOWN_COUNTRY_IDS.FRANCE:
      return i18n.global.t('country.france');
    case KNOWN_COUNTRY_IDS.UNITED_KINGDOM:
      return i18n.global.t('country.england');
    case KNOWN_COUNTRY_IDS.ROMANIA:
      return i18n.global.t('country.romania');
  }
}

export function getCountryTelCode(id: Nullish<CountryId>): string | undefined {
  switch (id) {
    case KNOWN_COUNTRY_IDS.BELGIUM:
      return '+32';
    case KNOWN_COUNTRY_IDS.THE_NETHERLANDS:
      return '+31';
    case KNOWN_COUNTRY_IDS.LUXEMBOURG:
      return '+352';
    case KNOWN_COUNTRY_IDS.GERMANY:
      return '+49';
    case KNOWN_COUNTRY_IDS.FRANCE:
      return '+33';
    case KNOWN_COUNTRY_IDS.UNITED_KINGDOM:
      return '+44';
    case KNOWN_COUNTRY_IDS.ROMANIA:
      return '+40';
  }
}

export default class Country {
  id: CountryId | null = null;
  description: string | null = null;

  static withId(id: CountryId): Country {
    const country = new Country();
    country.id = id;
    return country;
  }
}
